import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { HStack, VStack } from '@televet/kibble-ui/build/chakra';
import { Alert } from '@televet/kibble-ui/build/components/Alert';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from '@televet/kibble-ui/build/components/Modal';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { RouteBasePaths } from 'routes';

interface GlobalAutomationsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const GlobalAutomationsModal = ({ isOpen, onClose }: GlobalAutomationsModalProps): JSX.Element => {
  const { push } = useHistory();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalHeader>
        You&apos;re viewing Global Automations
        <ModalCloseButton />
      </ModalHeader>
      <ModalBody>
        <Alert
          title="Attention!"
          description="Changes made in Global Automations will affect multiple clinics."
          status="warning"
          hideCloseButton={true}
        />
        <VStack dir="column" alignItems="flex-start" mt={6}>
          <Text fontWeight="semibold">Before you save changes:</Text>
          <HStack>
            <Icon name="checkmarkBox" variant="success" />
            <Text>Double-check your work</Text>
          </HStack>
          <HStack>
            <Icon name="checkmarkBox" variant="success" />
            <Text>Notify stakeholders</Text>
          </HStack>
        </VStack>
      </ModalBody>
      <ModalFooter gap={3}>
        <Button variant="tertiary" onClick={(): void => push(RouteBasePaths.Settings)}>
          Get me out of here
        </Button>
        <Button variant="primary" onClick={onClose}>
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default GlobalAutomationsModal;
